import { useTranslation } from 'react-i18next';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { External, whatsapp } from './UI';
export default function Aside() {
  const {
    t
  } = useTranslation();
  return <External href={whatsapp} className="floating-chat"><FontAwesomeIcon icon={faWhatsapp} /><span>{t("chat_with_us")}</span></External>;
}
